import { render, staticRenderFns } from "./MarketingWysiwyg.vue?vue&type=template&id=513c34d0&scoped=true"
import script from "./MarketingWysiwyg.vue?vue&type=script&lang=js"
export * from "./MarketingWysiwyg.vue?vue&type=script&lang=js"
import style0 from "./MarketingWysiwyg.vue?vue&type=style&index=0&id=513c34d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "513c34d0",
  null
  
)

export default component.exports